import React from 'react';
import {
  Box, Heading, SimpleGrid, Stat, StatLabel, StatNumber, StatHelpText, VStack
} from '@chakra-ui/react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend
} from 'recharts';

const ObrasObstruccionTemporalDashboard: React.FC = () => {
  const data = [
    { name: 'Aprobado', cantidad: 8 },
    { name: 'En proceso', cantidad: 5 },
    { name: 'Cancelado', cantidad: 2 }
  ];

  return (
    <VStack spacing={6} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.600">
        Dashboard Obstrucción Temporal
      </Heading>

      <SimpleGrid columns={3} spacing={6}>
        <Stat>
          <StatLabel>Total registros</StatLabel>
          <StatNumber>15</StatNumber>
          <StatHelpText>Enero - Abril</StatHelpText>
        </Stat>
        <Stat>
          <StatLabel>Área Promedio (m²)</StatLabel>
          <StatNumber>120</StatNumber>
          <StatHelpText>Calculado</StatHelpText>
        </Stat>
        <Stat>
          <StatLabel>Costo Promedio ($)</StatLabel>
          <StatNumber>35000</StatNumber>
          <StatHelpText>Simulado</StatHelpText>
        </Stat>
      </SimpleGrid>

      <Box w="100%" h="300px" bg="white" p={4} rounded="md" shadow="md">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar dataKey="cantidad" fill="#3182CE" />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </VStack>
  );
};

export default ObrasObstruccionTemporalDashboard;
